var _rect, _rect2, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHybridHappening(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 575,
    height: 324,
    viewBox: "0 0 575 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 575,
    height: 324,
    rx: 10,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 575,
    height: 324,
    rx: 10,
    fill: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 575,
    height: 324,
    rx: 10,
    fill: "url(#paint0_radial_2397_18022)",
    fillOpacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.561 161.86H291.975C292.396 160.222 293.434 158.671 294.791 157.434H271.621V138.045C271.621 136.943 272.155 136.427 273.24 136.427H302.272C303.339 136.427 303.89 136.943 303.89 138.045V142.028C305.149 142.051 306.317 142.424 307.317 143.054V137.133C307.317 134.429 305.836 133 303.15 133H272.362C269.779 133 268.195 134.429 268.195 137.133V157.434H264.561C263.356 157.434 262.357 158.433 262.357 159.656C262.357 160.861 263.356 161.86 264.561 161.86Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.708 160.976C311.911 159.614 310.5 158.298 308.597 157.434C308.192 157.251 307.765 157.088 307.317 156.949C306.669 156.748 305.978 156.598 305.246 156.511C304.808 156.459 304.356 156.43 303.89 156.425C303.846 156.424 303.801 156.424 303.756 156.424C301.919 156.424 300.292 156.812 298.92 157.434C296.605 158.485 295.016 160.204 294.374 161.86C294.164 162.401 294.055 162.936 294.055 163.438C294.055 164.494 294.71 165.068 296.604 165.068H310.907C312.801 165.068 313.456 164.494 313.456 163.438C313.456 162.663 313.197 161.811 312.708 160.976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.317 146.095C307.985 146.949 308.393 148.054 308.393 149.284C308.393 150.546 307.986 151.683 307.317 152.562C306.728 153.336 305.938 153.909 305.045 154.193C304.675 154.311 304.288 154.379 303.89 154.39C303.849 154.392 303.808 154.392 303.767 154.392C301.253 154.392 299.129 152.165 299.129 149.307C299.118 146.506 301.264 144.313 303.767 144.313C303.808 144.313 303.849 144.314 303.89 144.315C305.244 144.354 306.483 145.029 307.317 146.095Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2397_18022)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-75 277.037L-36.4354 267.162C1.55368 257.286 78.683 237.534 155.237 253.994C231.79 270.453 281.844 297.904 385.473 297.903C489.102 297.903 539.156 277.037 577.145 267.161L615.71 226.823L615.71 415.298L577.145 415.298C539.156 415.298 462.027 415.298 385.473 415.298C308.92 415.298 231.79 415.298 155.237 415.298C78.683 415.298 1.55369 415.298 -36.4354 415.298L-75 415.298L-75 277.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.71 277.037L536.145 267.162C498.156 257.286 421.027 237.534 344.473 253.994C267.92 270.453 217.866 297.904 114.237 297.904C10.6075 297.904 -39.4462 277.037 -77.4353 267.161L-116 226.823L-116 415.298L-77.4353 415.298C-39.4462 415.298 37.683 415.298 114.237 415.298C190.79 415.298 267.92 415.298 344.473 415.298C421.027 415.298 498.156 415.298 536.145 415.298L574.71 415.298L574.71 277.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-25 299.159L13.5845 289.283C51.593 279.407 128.762 259.656 205.355 276.115C281.948 292.575 332.027 320.025 435.71 320.025C539.392 320.025 589.472 299.159 627.48 289.283L666.065 248.945L666.065 437.419L627.48 437.419C589.472 437.419 512.303 437.419 435.71 437.419C359.117 437.419 281.948 437.419 205.355 437.419C128.762 437.419 51.593 437.419 13.5845 437.419L-25 437.419L-25 299.159Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2397_18022",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.5 49.5) rotate(28.1046) scale(524.324 930.513)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#702DED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276042,
    stopColor: "#8764FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2F84EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DADEC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2397_18022"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 181H575V314C575 319.523 570.523 324 565 324H10C4.47716 324 0 319.523 0 314V181Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHybridHappening);
export default __webpack_public_path__ + "static/media/hybrid-happening.4c8e882f00ccd446542dcae1f8d73b91.svg";
export { ForwardRef as ReactComponent };